import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from "react";
import { Button, InfoTooltip, Modal } from "../../index";
function ActionCheckModal(props) {
    const { showIdExportModal, setShowIdExportModal, setLoading, setIdsForExport, setIdsWithReqNotMet, idsForExport, idsWithReqNotMet, completeAction, currentActionName, } = props;
    const [deletingItem, setDeletingItem] = useState("");
    const handleModalClose = () => {
        setShowIdExportModal(false);
        setLoading(false);
    };
    const handleItemRemoval = (id) => {
        setDeletingItem(id);
        setTimeout(() => {
            setIdsForExport(idsForExport.filter((item) => item !== id));
            const updatedFailureDetails = { ...idsWithReqNotMet._failureDetails };
            Object.keys(updatedFailureDetails).forEach((key) => {
                updatedFailureDetails[key] = updatedFailureDetails[key].filter((itemId) => itemId !== id);
            });
            setIdsWithReqNotMet({ _failureDetails: updatedFailureDetails });
            setDeletingItem("");
        }, 500);
    };
    const handleRemoveAllIssues = () => {
        const failingIds = Object.values(idsWithReqNotMet._failureDetails || {}).flat();
        setIdsForExport(idsForExport.filter((item) => !failingIds.includes(item)));
        setIdsWithReqNotMet({ _failureDetails: {} });
    };
    const handleCompleteAction = (actionName, ids) => {
        completeAction(actionName, ids);
        setShowIdExportModal(false);
        setIdsWithReqNotMet([]);
    };
    const failingIdsCount = new Set(Object.values(idsWithReqNotMet._failureDetails || {}).flat()).size;
    const exportItem = (id) => {
        const isFailingItem = Object.values(idsWithReqNotMet._failureDetails || {})
            .flat()
            .includes(id);
        const failureReasons = idsWithReqNotMet._failureDetails
            ? Object.entries(idsWithReqNotMet._failureDetails)
                .filter(([_, ids]) => ids.includes(id))
                .map(([requirement]) => requirement)
            : [];
        const tooltipContent = failureReasons.length > 0
            ? `Failed Requirements: ${failureReasons.join(", ")}`
            : "Could not get reasons for failure.";
        return (_jsxs("div", { className: `tol-table-action-modal-export-item-container ${deletingItem === id ? "deleting" : ""}`, children: [_jsxs("div", { className: `tol-table-action-modal-export-item ${isFailingItem ? "error" : ""}`, children: [_jsx("p", { children: id }), isFailingItem && _jsx(InfoTooltip, { contents: tooltipContent })] }), isFailingItem && (_jsx(Button, { type: "error", onClick: () => {
                        handleItemRemoval(id);
                    }, icon: "xmark", tooltip: "Remove", className: "tol-table-action-modal-export-item-remove-btn" }))] }, id));
    };
    const modalActionButtons = (_jsxs("div", { className: "tol-table-action-modal-btns", children: [_jsxs("div", { className: "tol-table-actions-modal-remove-all-btn-container", children: [_jsx(Button, { type: "primary", onClick: () => handleRemoveAllIssues(), text: "Remove All Issues", disabled: failingIdsCount === 0, className: "tol-table-action-modal-close-btn" }), failingIdsCount === 0 && (_jsx("p", { className: "tol-table-actions-modal-ready-indicator", children: "Action Ready" }))] }), _jsxs("div", { style: { display: "flex" }, children: [_jsx(Button, { type: "success", onClick: () => handleCompleteAction(currentActionName, idsForExport), disabled: failingIdsCount > 0, text: "Complete Action", className: "tol-table-action-modal-success-btn" }), _jsx(Button, { type: "error", onClick: () => handleModalClose(), text: "Cancel" })] })] }));
    const idCheckModalHeader = _jsx("h4", { children: "Some of your items cannot be actioned:" });
    const idCheckModalBody = (_jsxs("div", { className: "tol-table-action-modal-body-container", children: [_jsx("p", { children: "This is because they don't meet the criteria for actioning, please check and try again. You can also remove them from the list of items to be actioned." }), _jsx("h6", { children: `${idsForExport.length} items to be actioned; ${failingIdsCount} issues ${" "}
        ${failingIdsCount > 0 ? "highlighted" : "detected"}:` }), _jsx("div", { className: "tol-table-action-modal-export-item-list-container", children: idsForExport.map((id) => exportItem(id)) }), modalActionButtons] }));
    return (_jsx("div", { children: _jsx(Modal, { open: showIdExportModal, setOpen: setShowIdExportModal, size: "sm", children: idCheckModalBody, closeButton: false, header: idCheckModalHeader, onExited: () => setLoading(false) }) }));
}
export default ActionCheckModal;
